import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

function authHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

export async function getDashboard(token, data) {
  const res = await axios.get(`${API_URL}/api/centro-diurno/dashboard`, {
    headers: authHeaders(token),
    params: { data },
  });
  return res.data;
}

export async function getDisponibilita(token, da, a) {
  const res = await axios.get(`${API_URL}/api/centro-diurno/disponibilita`, {
    headers: authHeaders(token),
    params: { da, a },
  });
  return res.data;
}

export async function getPrenotazioni(token, params = {}) {
  const res = await axios.get(`${API_URL}/api/centro-diurno/prenotazioni`, {
    headers: authHeaders(token),
    params,
  });
  return res.data;
}

export async function createPrenotazione(token, body) {
  const res = await axios.post(`${API_URL}/api/centro-diurno/prenotazioni`, body, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updatePrenotazione(token, id, body) {
  const res = await axios.put(`${API_URL}/api/centro-diurno/prenotazioni/${id}`, body, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function deletePrenotazione(token, id) {
  const res = await axios.delete(`${API_URL}/api/centro-diurno/prenotazioni/${id}`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getPresenze(token, data) {
  const res = await axios.get(`${API_URL}/api/centro-diurno/presenze`, {
    headers: authHeaders(token),
    params: { data },
  });
  return res.data;
}

export async function checkIn(token, body) {
  const res = await axios.post(`${API_URL}/api/centro-diurno/presenze/check-in`, body, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function checkOut(token, presenzaId) {
  const res = await axios.post(
    `${API_URL}/api/centro-diurno/presenze/check-out`,
    { presenza_id: presenzaId },
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function getCarnetAlerts(token) {
  const res = await axios.get(`${API_URL}/api/centro-diurno/carnet-alert`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getMezzi(token) {
  const res = await axios.get(`${API_URL}/api/centro-diurno/mezzi`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createMezzo(token, body) {
  const res = await axios.post(`${API_URL}/api/centro-diurno/mezzi`, body, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getAutisti(token) {
  const res = await axios.get(`${API_URL}/api/centro-diurno/autisti`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function createAutista(token, body) {
  const res = await axios.post(`${API_URL}/api/centro-diurno/autisti`, body, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getGiri(token, data) {
  const res = await axios.get(`${API_URL}/api/centro-diurno/giri`, {
    headers: authHeaders(token),
    params: { data },
  });
  return res.data;
}

export async function generaGiro(token, body) {
  const res = await axios.post(`${API_URL}/api/centro-diurno/giri/genera`, body, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function ottimizzaGiro(token, giroId, params = {}) {
  const res = await axios.post(
    `${API_URL}/api/centro-diurno/giri/${giroId}/ottimizza`,
    null,
    { headers: authHeaders(token), params }
  );
  return res.data;
}

export async function getReportMensile(token, mese, fascicoloId) {
  const res = await axios.get(`${API_URL}/api/centro-diurno/report/mensile`, {
    headers: authHeaders(token),
    params: { mese, fascicolo_id: fascicoloId || undefined },
  });
  return res.data;
}

export async function setPacchetto(token, fascicoloId, body) {
  const res = await axios.put(
    `${API_URL}/api/centro-diurno/fascicoli/${fascicoloId}/pacchetto`,
    body,
    { headers: authHeaders(token) }
  );
  return res.data;
}

export async function getConfig(token) {
  const res = await axios.get(`${API_URL}/api/centro-diurno/config`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getPacchettiConfig(token) {
  const res = await axios.get(`${API_URL}/api/centro-diurno/config/pacchetti`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function savePacchettiConfig(token, body) {
  const res = await axios.put(`${API_URL}/api/centro-diurno/config/pacchetti`, body, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function getCarnetOspiti(token) {
  const res = await axios.get(`${API_URL}/api/centro-diurno/carnet`, {
    headers: authHeaders(token),
  });
  return res.data;
}

export async function updateCarnetOspite(token, fascicoloId, body) {
  const res = await axios.put(`${API_URL}/api/centro-diurno/fascicoli/${fascicoloId}/carnet`, body, {
    headers: authHeaders(token),
  });
  return res.data;
}
